<template>
  <!-- 工单详情属性基础表格 -->
  <XTable ref="table" :dataApi="dataApi" :columns="columns" :paging="false" :params="{id: workOrderId || getWorkOrderId}" v-on="$listeners" v-bind="$attrs">
  </XTable>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props:{
    dataApi: Function,
    columns: Array,
    workOrderId: Number
  },
  data(){
    return {
    }
  },
  computed:{
    ...mapGetters(['getWorkOrderId']),
  },

  methods:{
    //获取列表数据
    loadTableData(){
      if(this.workOrder){
        this.$refs.table.searchList()
      }
    }
  }
}
</script>
<style lang="less" scoped>

</style>